// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__lQill","header":"PatientQuestionnaire_header__2TcPF","info":"PatientQuestionnaire_info__28Lno"};